import { Text } from '@interco/inter-ui/components/Text'

import * as S from './styles'

interface WarningProps {
  text: string
}

const WarningIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M1 9C1 4.58172 4.58172 1 9 1H23C27.4183 1 31 4.58172 31 9V23C31 27.4183 27.4183 31 23 31H9C4.58172 31 1 27.4183 1 23V9Z"
      fill="#F6F6F5"
    />
    <path
      d="M3 9C3 5.68629 5.68629 3 9 3H23C26.3137 3 29 5.68629 29 9V23C29 26.3137 26.3137 29 23 29H9C5.68629 29 3 26.3137 3 23V9Z"
      fill="#756E6D"
    />
    <path
      d="M16 12C16.7594 12 17.375 11.3844 17.375 10.625C17.375 9.86561 16.7594 9.25 16 9.25C15.2406 9.25 14.625 9.86561 14.625 10.625C14.625 11.3844 15.2406 12 16 12Z"
      fill="white"
    />
    <path
      d="M17.25 14.5C17.25 13.8096 16.6904 13.25 16 13.25C15.3096 13.25 14.75 13.8096 14.75 14.5L14.75 22C14.75 22.6904 15.3096 23.25 16 23.25C16.6904 23.25 17.25 22.6904 17.25 22L17.25 14.5Z"
      fill="white"
    />
  </svg>
)

const Warning = ({ text }: WarningProps) => (
  <S.Warning>
    <div style={{ width: 32, height: 32 }}>
      <WarningIcon />
    </div>
    <Text
      variant="headline-h3"
      semiBold
      style={{
        fontFamily: 'Sora',
        color: 'var(--gray400)',
        fontSize: '12px',
      }}
    >
      {text}
    </Text>
  </S.Warning>
)

export default Warning
